
import { BackupService, IOldBackup } from "@/services/backup-service";
import { printLocalDateTime } from "@/utils/pretty-print";
import { JobService } from "@/services/job-service";
import Vue from "vue";
import { AuthService } from "@/services/auth-service";
import { MODULE } from "@/config/modules";
export default Vue.extend({
	data(){
		return {
			backups: [] as IOldBackup[],
			jobs: JobService.getJobs(),
		};
	},
	computed: {
		restoreDisabled():boolean {
			return this.jobs.find(j=>j.Name == "restore-backup") != null;
		}
	},
	methods: {
		async fetchBackups(){
			this.backups = await BackupService.getOldBackups();
		},
		async downloadBackup(fileName:string){
			await BackupService.downloadOldBackup(fileName);
		},
		onJobStopped(){
			this.fetchBackups();
		},
		async restoreBackup(backup:IOldBackup){
			let confirm = await this.$confirmBuilder(this.$ct("are-you-sure-you-want-to-restore-backup")).setWarningTitle().show();
			if (!confirm) return;
			let oldDate = new Date();
			oldDate.setDate(oldDate.getDate()-14);
			if (backup.LastModified.getTime() < oldDate.getTime()){
				confirm = await this.$confirmBuilder(this.$ct("backup-db-version-incorrect-warning")).setWarningTitle().show();
				if (!confirm) return;
			}
			await BackupService.restoreOldBackup(backup.Name);
		},
		printLocalDateTime(date:Date):string{
			return printLocalDateTime(date);
		}
	},
	created(){
		if (!AuthService.hasModule(MODULE.ONLINE_BACKUP)) return;
		this.fetchBackups();
		JobService.on("job-stopped/create-backup_0", this.onJobStopped);
	},
	destroyed(){
		JobService.off("job-stopped/create-backup_0", this.onJobStopped);
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	},
});
